import React from "react";
import ReactDOM from "react-dom";
import styles from "./modal.module.css";
import classNames from "classnames";

const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  size = "medium",
  modalClassName,
  titleClassName,
  contentClassName,
  closeButtonClassName,
}) => {
  if (!isOpen) return null;

  // modal size classes
  const modalSizeClass = {
    small: styles.small,
    medium: styles.medium,
    large: styles.large,
  }[size];

  return ReactDOM.createPortal(
    <div className={styles.overlay} onClick={onClose}>
      <div
        className={classNames(styles.modal, modalSizeClass, modalClassName)}
        onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
      >
        {title && <h5 className={classNames(styles.title, titleClassName)}>{title}</h5>}
        <div className={classNames(styles.content, contentClassName)}>{children}</div>
        <button
          className={classNames(styles.closeBtn, closeButtonClassName)}
          onClick={onClose}
          aria-label="Close modal"
        >
          <i className="bi bi-x-circle" />
        </button>
      </div>
    </div>,
    document.getElementById("root") // make sure your index.html has <div id="modal-root"></div>
  );
};

export default Modal;
